export enum AnalyticsEvents {
  BOOKING_FILTER_CHANGE = 'BOOKING_FILTER_CHANGE',
  BOOKING_PROVIDER_SELECTED = 'BOOKING_PROVIDER_SELECTED',
  BOOKING_FORM_FIELD_CHANGED = 'BOOKING_FORM_FIELD_CHANGED',
  BOOKING_TIME_SLOT_SELECTED = 'BOOKING_TIME_SLOT_SELECTED',
  BOOKING_FORM_BENEFITS_VERIFICATION_START = 'BOOKING_FORM_BENEFITS_VERIFICATION_START',
  BOOKING_FORM_BENEFITS_VERIFICATION_STATUS = 'BOOKING_FORM_BENEFITS_VERIFICATION_STATUS',
  BOOKING_FORM_SUBMITTED = 'BOOKING_FORM_SUBMITTED',
  BOOKING_FORM_SUBMIT_FAILED = 'BOOKING_FORM_SUBMIT_FAILED'
}

export enum NewTherapistAnalyticsEvents {
  NEW_THERAPIST_BOOKING_FILTER_CHANGE = 'NEW_THERAPIST_BOOKING_FILTER_CHANGE',
  NEW_THERAPIST_BOOKING_PROVIDER_SELECTED = 'NEW_THERAPIST_BOOKING_PROVIDER_SELECTED',
  NEW_THERAPIST_BOOKING_FORM_FIELD_CHANGED = 'NEW_THERAPIST_BOOKING_FORM_FIELD_CHANGED',
  NEW_THERAPIST_BOOKING_TIME_SLOT_SELECTED = 'NEW_THERAPIST_BOOKING_TIME_SLOT_SELECTED'
}

export enum ReferralNewTherapistBookingFormFieldChanged {
  REFERRAL_NEW_THERAPIST_BOOKING_TIME_SLOT_SELECTED = 'REFERRAL_NEW_THERAPIST_BOOKING_TIME_SLOT_SELECTED',
  REFERRAL_NEW_THERAPIST_BOOKING_FORM_FIELD_CHANGED = 'REFERRAL_NEW_THERAPIST_BOOKING_FORM_FIELD_CHANGED'
}
